import i18next from 'i18next'
import { Event } from '../../../models/Events/Events'

export function capitalize(item: string | null) {
  return !!item
    ? item
        .split(' ')
        .map(word => {
          return word.charAt(0).toUpperCase() + word.toLowerCase().slice(1)
        })
        .join(' ')
    : ''
}

export function daysCount(events: Event[]): number {
  const allUniqueDays = Array<Set<string>>()

  events.forEach(event => {
    const uniqueDays = new Set<string>()
    event.sessions.forEach(session => {
      if (session.start_date) {
        // Convert to Date first because TS thinks `session.start_date` is a Date, but the browser thinks it's a string without it
        const date = new Date(session.start_date)
        const day = date.toISOString().split('T')[0]
        uniqueDays.add(day)
      }

    });
    allUniqueDays.push(uniqueDays)
  });

  const eventLengths: number[] = allUniqueDays.map((s) => s.size)

  return Math.max(...eventLengths)
}


export const getInCompanyFormUrl = () : string => '/formulieren/1190'

export const showAvailableSeats = (availableSeats: number| null): string => {
  if (availableSeats) {
    if (availableSeats == 0) return i18next.t('courses:noAvailablePlaces');
    if (availableSeats == 1) return i18next.t('courses:oneAvailablePlace');
    if (availableSeats > 1 && availableSeats < 100) return i18next.t('courses:numberOfAvailablePlaces', { places: availableSeats })
  }
  return "";
}
